<template>
    <div class="container">
        <h1 class="title">Top ventajas de Ademass para<br> recruiters</h1>
        <div class="tbody">
            <div class="imgg">
            <img src="/external/rectangle12190-c9v2-400h.png" alt="Rectangle12190" class="frame-rectangle12" />
        </div>
            <div class="right-text">
                <h3 class="title-text" v-show="windowWidth>=600">Base de datos de candidatos exclusiva</h3>
                <h3 class="title-text" v-show="windowWidth<600">Base de datos de candidatos<br> exclusiva</h3>
                <p class="text-2">Nuestra comunidad de desarrolladores cuenta
                    con más de 65.000 profesionales formados con las últimas tecnologías y certificados por nosotros.</p>
            </div>
        </div>
        <div class="tbody">
            <div class="left-text">
                <h3 class="title-text-green">Profesionales validados</h3>
                <p class="text">Somos expertos ultra especializados en el sector del desarrollo, por
                    lo que nuestra selección de candidatos es impecable.<br><br>
                    Revisamos certificaciones, diseñamos pruebas para validar sus
                    competencias técnicas y afinamos la selección según las necesidades de
                    tu empresa.</p>
            </div>
            <img src="/external/rectangle231107-5cxk-400h.png" alt="Rectangle231107" class="frame-rectangle23" />
        </div>
        <div class="tbody">
            <img src="/external/rectangle18198-iopb-400h.png" alt="Rectangle18198" class="frame-rectangle123" />
            <div class="right-text-2">
                <h3 class="title-text">Sencillez</h3>
                <p class="text-end">Publica tus ofertas de manera sencilla y automatizada y controla todo el proceso desde tu panel de administración personalizado.<br><br>
                    Contacta con nosotros si necesitas un servicio de selección o de formación específico para tu empresa.</p>
            </div>
        </div>
        <div class="tbody">
            <div class="left-text-2">
                <div class="titles">
                <h3 class="title-text-green-2" v-if="windowWidth>=600">Totalmente Gratuito</h3>
                <h3 class="title-text-green-2" v-else>Totalmente<br> Gratuito</h3>
            
                <p class="text-end-title">Sin ningún coste para tu empresa:</p>
            </div>
                <div class="check">
                    <v-icon name="bi-check-circle"
                        style="color: rgba(196, 207, 44, 1); scale: 1.5; margin-right: 0;"></v-icon>
                    <p class="text-finally">Publica todas las ofertas que quieras y accede al mejor talento dev para cubrir las necesidades de programadores para tu proyecto.<br>
                        Sin letra pequeña ni condiciones, todo es gratis.
                    </p>
                </div>
            </div>
                <div class="img-finally">
            <img src="/external/jobs.png" class="frame-rectangle21" />
        </div>
        </div>

    </div>
</template>
    
<script  setup>
import useWindowWidth from '@/composables/useWindowWidth';

const { windowWidth } = useWindowWidth();
</script>
    
<style scoped>
.check {
    display: flex;
    height: 110px;
   padding-top: 5px;

}

.container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    width: 100%;
}

.title {
    color: rgba(39, 52, 68, 1);
    font-size: 60px;
    font-style: Black;
    text-align: center;
    font-family: Darker Grotesque;
    font-weight: 900;
    line-height: 94.9999988079071%;
}

.frame-rectangle12 {
    width: 291px;
    height: 326px;
    border-radius: 25px;
    box-shadow: -30px -30px 0 0 #8F8181, -60px 40px 0px 20px #f9fae9;
    top: 10px;
    left: 10px;
}

.frame-rectangle123 {
    width: 291px;
    height: 326px;
    border-radius: 25px;
    box-shadow: -30px -30px 0 0 #8F8181, 50px 70px 0px 0px #eaf6fe;
    top: 10px;
    left: 10px;
    margin-right: 100px;
}

.title-text {
    margin-top: 100px;
    color: rgba(46, 163, 242, 1);
    width: 420px;
    font-size: 40px;
    font-style: Bold;
    text-align: left;
    font-family: Darker Grotesque;
    font-weight: 700;
    margin-left: 25px;
    margin-bottom: 5px;
    line-height: 94.9999988079071%;
}

.title-text-green {
    color: rgba(196, 207, 44, 1);
    width: 420px;
    font-size: 40px;
    font-style: Bold;
    text-align: left;
    font-family: Darker Grotesque;
    font-weight: 700;
    margin-left: 25px;
    margin-bottom: 5px;
    line-height: 94.9999988079071%;
}

.title-text-green-2 {
    color: rgba(196, 207, 44, 1);
    width: 420px;
    font-size: 40px;
    font-style: Bold;
    text-align: left;
    font-family: Darker Grotesque;
    font-weight: 700;
    margin-bottom: 5px;
    line-height: 94.9999988079071%;
}


.tbody {
    display: flex;
    width: 100%;
    justify-content: center;
    margin-top: 50px;
    flex-wrap: wrap;
}

.text {
    margin-right: 20px;
    margin-top: 0;
    height: 100%;
    margin-left: 30px;
    color: rgba(39, 52, 68, 1);
    max-width: 400px;
    height: auto;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
    margin-bottom: 80px;
}

.text-2 {
    margin-right: 20px;
    margin-top: 0;
    height: 100%;
    margin-left: 30px;
    color: rgba(39, 52, 68, 1);
    max-width: 400px;
    height: auto;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
    margin-bottom: 80px;
}

.text-finally {
    margin-right: 20px;
    margin-top: 0;
    height: 100%;
    margin-left: 8px;
    color: rgba(39, 52, 68, 1);
    max-width: 400px;
    height: auto;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}

.text-check {
    margin-right: 20px;
    margin-top: 0;
    margin-left: 30px;
    color: rgba(39, 52, 68, 1);
    max-width: 400px;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;

}

.text-end {
    align-items: start;
    margin-right: 20px;
    margin-top: 0;
    margin-left: 30px;
    color: rgba(39, 52, 68, 1);
    max-width: 400px;
    height: auto;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}

.text-end-title {
    align-items: start;
    margin-right: 182px;
    margin-top: 0;
    margin-bottom: 15px;
    margin-left: 0px;
    color: rgba(39, 52, 68, 1);
    max-width: 450px;
    font-size: 24px;
    font-style: Medium;
    font-family: Darker Grotesque;
    font-weight: 500;
    line-height: 94.9999988079071%;
}

.right-text {
    display: flex;
    flex-direction: column;
}
.right-text-2 {
    display: flex;
    flex-direction: column;
}

.frame-rectangle23 {
    width: 291px;
    height: 326px;
    border-radius: 25px;
    box-shadow: 30px 30px 0 0 #8F8181, -40px -55px 0px 0px #eaf6fe;
}

.frame-rectangle21 {
    width: 291px;
    height: 326px;
    border-radius: 25px;
    box-shadow: 30px -30px 0 0 #8F8181, 80px -75px 0px 0px #f9fae9;
}

img {
    margin: 30px;
}
.left-text-2{
    display: flex;
    flex-direction: column;
    
}

@media screen and (max-width: 800px) {
    .img-finally{
     padding-right:  50px;
    }
    .title-text-green{
        display: flex;
        width: 100%;
        margin-right: 10px;
    }
    .title-text-green-2{
        display: flex;
        width: 380px;
        margin-bottom: 20px;

    }
   .titles{
    max-width: 88%;
   }
    
    .container {
        margin-top: 50px;
        margin-bottom: 20px;
        align-items: center;
        justify-content: center;
    }

    .check {
        height: 170px;
        padding: 20px;
        width: 80%;
        line-height: 94.9999988079071%;
    }

    .tbody {
        margin-top: 20px;
        margin-bottom: 10px;
        align-items: center;
        flex-direction: column;
    }
    .right-text{
        display: flex;
        flex-direction: column;
        width: 90%;
        height: auto;
       
    }
    .right-text-2{
        display: flex;
        flex-direction: column;
        width: 90%;
        height: auto;
        margin-right: 60px;
       
    }
    .frame-rectangle21 {
        margin-top: 0;
        border-radius: 25px;
        box-shadow: 20px -20px 0 0 #8F8181, 40px -35px 0px 0px #f9fae9;
    }
    .left-text{
        display: flex;
        flex-direction: column;
        width: 90%;
        height: auto;
    }
    .left-text-2{
        display: flex;
        justify-content: center;
        align-items: center;
        flex-direction: column;
        width: 80%;
        height: auto;
        margin-right: 40px;
    }
    .imgg{
        display: flex;
        width: 100%;
        justify-content: center;
        align-items: center;
    }
    .frame-rectangle12{
        margin-left: 75px;
        width: 70%;
    }
    .text-end-title {
        margin-right: 5px;
        margin-left: 20px;
    }

    .text-2 {
        margin-bottom: 0;
    }
    .text-finally{
        line-height: 94.9999988079071%;
    }
    .text-end-title{
        margin-bottom: 0;
    }
}



</style>